export enum SearchTableRowType { //eslint-disable-line @stencil-community/ban-exported-const-enums
    Text = 'text',
    Status = 'status',
    Link = 'link',
    File = 'file',
    Date = 'date',
    Action = 'action',
    List = 'list',
    SanitizedText = 'sanitized-text'
};
